import Axios from "axios";
import {
    SET_ASSET_DISPOSAL_LIST,
    UNSET_ASSET_DISPOSAL_LIST,
    SET_ASSET_REGISTER_DISPOSAL_LIST,
    UNSET_ASSET_REGISTER_DISPOSAL_LIST,
    SET_EDITING_ASSET_DISPOSAL,
    UNSET_EDITING_ASSET_DISPOSAL,
} from "@/store/mutation-types";

import { saveUpdateAssetDisposal, getAssetDisposalList,getAssetRegisterDisposalsList, getAssetDisposalById } from "@/store/api";

const state = {
    getAssetDisposalList: [],
    getAssetRegisterDisposalsList: [],
    getEditingAssetDisposal: null,
};

const getters = {
    getAssetDisposalList(state) {
        return state.getAssetDisposalList;
    },
    getAssetRegisterDisposalsList(state) {
        return state.getAssetRegisterDisposalsList;
    },
    getEditingAssetDisposal(state) {
        return state.getEditingAssetDisposal;
    }
};

const mutations = {
    [SET_ASSET_DISPOSAL_LIST](state, data) {
        state.getAssetDisposalList = data;
    },
    [UNSET_ASSET_DISPOSAL_LIST](state) {
        state.getAssetDisposalList = [];
    },
    [SET_ASSET_REGISTER_DISPOSAL_LIST](state, data) {
        state.getAssetRegisterDisposalsList = data;
    },
    [UNSET_ASSET_REGISTER_DISPOSAL_LIST](state) {
        state.getAssetRegisterDisposalsList = [];
    },
    [SET_ASSET_DISPOSAL_LIST](state, data) {
        state.getAssetDisposalList = data;
    },
    [UNSET_ASSET_DISPOSAL_LIST](state) {
        state.getAssetDisposalList = [];
    },
    [SET_EDITING_ASSET_DISPOSAL](state, data) {
        state.getEditingAssetDisposal = data;
    },
    [UNSET_EDITING_ASSET_DISPOSAL](state) {
        state.getEditingAssetDisposal = null;
    }
};

const actions = {
    saveUpdateAssetDisposal({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetDisposal, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetDisposalList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetDisposalList, { params: data})
                .then(function (response) {
                commit('SET_ASSET_DISPOSAL_LIST', response.data.data)
                resolve(response);
                })
                .catch(function (error) {
                commit('UNSET_ASSET_DISPOSAL_LIST')
                reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetRegisterDisposalsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetRegisterDisposalsList, { params: data})
                .then(function (response) {
                commit('SET_ASSET_REGISTER_DISPOSAL_LIST', response.data.data)
                resolve(response);
                })
                .catch(function (error) {
                commit('UNSET_ASSET_REGISTER_DISPOSAL_LIST')
                reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetDisposalById({ commit }, data) {
        const getAssetDisposalRecordById = `${getAssetDisposalById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getAssetDisposalRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};

